import React from 'react';
import Content from '../../content';
import Column from '../../column/index';
import ContentWrapper from './content-wrapper';

const Quote = ({
  // id,
  columnWidth,
  align,
  justify,
  card,
  order,
  content,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
    flexDirection="column"
  >
    {content?.data?.childMarkdownRemark?.html && (
      <ContentWrapper>
        <Content
          content={content}
          textAlign={justify}
        />
      </ContentWrapper>
    )}
  </Column>
);

export default Quote;
